document.addEventListener("DOMContentLoaded", function () {
  const tabButtons = document.querySelectorAll(".tabbed-content--tabs button");
  const tabContents = document.querySelectorAll(".tabbed-content--content");

  // Hide all tab contents initially
  tabContents.forEach((content, index) => {
    if (index === 0) {
      content.classList.add("active"); // Keep the first content visible
    } else {
      content.classList.remove("active"); // Hide others
    }
  });

  // Ensure the first button is also active on load
  tabButtons.forEach((btn, index) => {
    if (index === 0) {
      btn.classList.add("active");
    } else {
      btn.classList.remove("active");
    }
  });

  // Tab click functionality
  tabButtons.forEach((button, index) => {
    button.addEventListener("click", function () {
      // Remove active class from all buttons
      tabButtons.forEach((btn) => btn.classList.remove("active"));
      this.classList.add("active");

      // Hide all content blocks
      tabContents.forEach((content) => content.classList.remove("active"));

      // Show only the corresponding tab content
      const correspondingContent = tabContents[index];
      if (correspondingContent) {
        correspondingContent.classList.add("active");
      }
    });
  });
});
